module.exports = __webpack_public_path__ + "favicon-16x16.620e1109.png";